import { render } from "./FormaTeurs.vue?vue&type=template&id=ffb022e0&scoped=true&ts=true"
import script from "./FormaTeurs.vue?vue&type=script&lang=ts"
export * from "./FormaTeurs.vue?vue&type=script&lang=ts"

import "./FormaTeurs.vue?vue&type=style&index=0&id=ffb022e0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ffb022e0"]])

export default __exports__